// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const cargoNetLoad = defineModel({
  id: "cargo-net-load",
  batchId: "future",
  name: "Cargo-net load",
  tags: ["scenery","cargo","net","load","low-poly","age-of-mcp","future"],
  summary: "A netted bundle of mixed goods, ready to lift or haul.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.3, 0.3, 0.3), color: "#a9763f", position: [-0.12, 0.16, 0.06] },
      { geometry: new THREE.CylinderGeometry(0.1118, 0.1118, 0.3, 9), color: "#7a5a36", position: [0.18, 0.16, -0.06] },
      { geometry: new THREE.SphereGeometry(0.13, 6, 5), color: "#c7b27a", position: [0.1, 0.13, 0.18], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.SphereGeometry(0.12, 6, 5), color: "#bba76e", position: [-0.18, 0.34, 0], scale: [1, 0.82, 1.08] },
      { geometry: new THREE.BoxGeometry(0.015, 0.015, 0.56), color: "#b9a574", position: [-0.18, 0.333, 0] },
      { geometry: new THREE.BoxGeometry(0.015, 0.015, 0.56), color: "#b9a574", position: [-0.06, 0.351, 0] },
      { geometry: new THREE.BoxGeometry(0.015, 0.015, 0.56), color: "#b9a574", position: [0.06, 0.351, 0] },
      { geometry: new THREE.BoxGeometry(0.015, 0.015, 0.56), color: "#b9a574", position: [0.18, 0.333, 0] },
      { geometry: new THREE.BoxGeometry(0.56, 0.015, 0.015), color: "#b9a574", position: [0, 0.333, -0.18] },
      { geometry: new THREE.BoxGeometry(0.56, 0.015, 0.015), color: "#b9a574", position: [0, 0.351, -0.06] },
      { geometry: new THREE.BoxGeometry(0.56, 0.015, 0.015), color: "#b9a574", position: [0, 0.351, 0.06] },
      { geometry: new THREE.BoxGeometry(0.56, 0.015, 0.015), color: "#b9a574", position: [0, 0.333, 0.18] },
    ],
  animations: [],
});
